import { EducationLevel, EmploymentStatus, PoliticallyExposedPersonKind } from "../types/user";
import { IncomeType } from "../types/user";

export const autoflowEmploymentStatuses = [
  "employed",
  "entrepreneur",
  "maternity_leave",
  "public_servant",
  "retired",
  "self_employed"
];

export const educationLevelOptions: { value: EducationLevel, svgSymbolId: SvgSymbolId }[] = [
  { value: "basic", svgSymbolId: "home-loan" },
  { value: "secondary", svgSymbolId: "bar-chart" },
  { value: "vocational", svgSymbolId: "equipment-loan" },
  { value: "higher", svgSymbolId: "education" },
];

export const employmentStatuses = [
  "employed",
  "entrepreneur",
  "maternity_leave",
  "other",
  "public_servant",
  "retired",
  "student",
  "self_employed",
  "unemployed"
];

export const employmentStatusesOptions: { value: EmploymentStatus, svgSymbolId: SvgSymbolId }[] = [
  { value: "employed", svgSymbolId: "briefcase" },
  { value: "entrepreneur", svgSymbolId: "rocket" },
  { value: "maternity_leave", svgSymbolId: "baby-stroller" },
  { value: "public_servant", svgSymbolId: "suit" },
  { value: "self_employed", svgSymbolId: "consumer-loan" },
  { value: "retired", svgSymbolId: "lounge-chair" },
  { value: "student", svgSymbolId: "square-cap" },
  { value: "unemployed", svgSymbolId: "magnifying-glass-briefcase" },
  { value: "other", svgSymbolId: "circle-question" },
];

export const IncomeTypes: IncomeType[] = [
  "salary",
  "dividends",
  "pension",
  "rental_income",
  "social_benefits",
  "other",
]

export const maritalStatusesOptions = [
  { value: "single" },
  { value: "cohabiting" },
  { value: "married" },
  { value: "divorced" },
  { value: "widow" },
]

export const politicallyExposedPersonKinds: PoliticallyExposedPersonKind[] = [
  "business_partner",
  "family_member",
  "personal"
]
